import { uiText, useUiLanguage } from '@/i18n/interface';
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { UserPlus, Loader2 } from 'lucide-react';
import { toast } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';

const FillStudentDataButton: React.FC = () => {
  useUiLanguage();
  const [isLoading, setIsLoading] = useState(false);

  const handleFillData = async () => {
    setIsLoading(true);

    try {
      console.log('Calling fill-student-data function...');

      const { data, error } = await supabase.functions.invoke('fill-student-data', {
        body: {}
      });

      if (error) {
        console.error('Error calling function:', error);
        throw error;
      }

      console.log('Function response:', data);

      toast({
        title: uiText("Student Data Updated"),
        description: uiText("Successfully filled missing data for {{value0}} students.", { value0: data.totalStudents }),
      });

    } catch (error) {
      console.error('Error filling student data:', error);
      toast({
        title: uiText("Update Failed"),
        description: uiText("Failed to fill student data. Please try again."),
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleFillData}
      disabled={isLoading}
      className="bg-blue-600 hover:bg-blue-700"
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
      ) : (
        <UserPlus className="h-4 w-4 mr-2" />
      )}
      {isLoading ? uiText("Filling Data...") : uiText("Fill Missing Student Data")}
    </Button>
  );
};

export default FillStudentDataButton;